<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/H6JyXG/e9781429994552_cover.jpg?1726444355269" alt="This image is the cover for the book Broken as Things Are"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Broken as Things Are
      </h1>
      <p class="bookDescription body article font2">
        <p>From the day that Morgan-Lee is born, her extraordinarily beautiful and withdrawn older brother, Ginx, is obsessed by her. Inhabiting their own parallel world, the two communicate through a secret language and make-believe stories; when Morgan-Lee begins to explore friendships beyond their closed circle, however, Ginx becomes increasingly disturbed. In luminous prose, Martha Witt explores the intense and private world inhabited by these siblings and the inevitable and necessary pain of their separation.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Martha Witt
      </h2>
      
      <p class="authorDescription body article"><P><B>Martha Witt</B> grew up in Hillsborough, North Carolina. Currently, she lives in New York City. <I>Broken as Things Are</I> is her first novel.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?55faf40a